<p-table
  [value]="displayRows"
  [lazy]="true"
  (onLazyLoad)="onLazyLoad($event)"
  [loading]="loading"
  [paginator]="true"
  [rows]="rows"
  [first]="first"
  [totalRecords]="totalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first}-{last} de {totalRecords}"
  [scrollable]="true"
  scrollHeight="flex"
  paginatorDropdownAppendTo="body"
  styleClass="mailbox-message-table p-datatable-sm">

  <ng-template pTemplate="body" let-row>

    <!-- cabecera de conversacion: se pulsa para desplegarla, y al desplegarla se abre su mensaje mas reciente -->
    <tr *ngIf="row.kind === 'thread'" class="message-row thread-row"
        [class.message-unread]="row.thread.unread"
        [class.message-selected]="threadHasSelected(row.thread)"
        (click)="toggleThread(row.thread)">
      <td>
        <div class="flex align-items-start gap-2">
          <i class="pi thread-toggle"
             [ngClass]="isExpanded(row.thread.key) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>

          <div class="message-main">
            <div class="flex align-items-center gap-2">
              <span class="message-sender">{{row.thread.participants}}</span>
              <span *ngIf="row.thread.count > 1" class="thread-count">{{row.thread.count}}</span>
              <span class="message-date">{{dateLabel(row.thread.date)}}</span>
            </div>
            <div class="flex align-items-center gap-2">
              <i *ngIf="row.thread.answered" class="pi pi-reply status-answered" pTooltip="Respondido"></i>
              <i *ngIf="row.thread.forwarded" class="pi pi-arrow-up-right status-forwarded" pTooltip="Reenviado"></i>
              <span class="message-subject">{{row.thread.subject}}</span>
              <i *ngIf="row.thread.hasAttachments" class="pi pi-paperclip message-icon" title="Con adjuntos"></i>
              <i *ngIf="row.thread.flagged" class="pi pi-star-fill message-icon message-flagged" title="Destacado"></i>
              <i *ngIf="stateOf(row.thread.key)?.loading" class="pi pi-spin pi-spinner message-icon"
                 title="Buscando el resto de la conversación"></i>
              <i *ngIf="stateOf(row.thread.key)?.truncated" class="pi pi-exclamation-triangle message-icon"
                 pTooltip="La conversación es muy larga: se muestran los mensajes más recientes"></i>
            </div>
          </div>
        </div>
      </td>
    </tr>

    <!-- un mensaje: suelto cuando no se agrupa, o dentro de su conversacion cuando si -->
    <tr *ngIf="row.kind === 'message'" class="message-row"
        [class.message-child]="row.child"
        [class.message-unread]="!row.message.seen"
        [class.message-selected]="row.message.uid === selectedUid"
        (click)="messageSelected.emit(row.message)">
      <td>
        <div class="flex align-items-start gap-2">
          <div class="message-main">
            <div class="flex align-items-center gap-2">
              <span class="message-sender">{{senderLabel(row.message)}}</span>
              <span class="message-date">{{dateLabel(row.message.date)}}</span>
            </div>
            <div class="flex align-items-center gap-2">
              <i *ngIf="row.message.answered" class="pi pi-reply status-answered" pTooltip="Respondido"></i>
              <i *ngIf="row.message.forwarded" class="pi pi-arrow-up-right status-forwarded" pTooltip="Reenviado"></i>
              <span class="message-subject">{{row.message.subject || '(sin asunto)'}}</span>
              <i *ngIf="row.message.hasAttachments" class="pi pi-paperclip message-icon" [title]="row.message.attachmentCount + ' adjunto(s)'"></i>
              <i *ngIf="row.message.flagged" class="pi pi-star-fill message-icon message-flagged" title="Destacado"></i>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="loadingbody">
    <tr *ngFor="let placeholder of [1,2,3,4,5,6,7,8]">
      <td>
        <p-skeleton width="60%" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="85%"></p-skeleton>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td>
        <div class="p-4 text-center text-color-secondary">No hay mensajes en esta carpeta.</div>
      </td>
    </tr>
  </ng-template>
</p-table>
